import { useState } from "react";

import { Page } from "~/api/Api";
import { IgnoreRecrawlPayload } from "~/pages/dashboard/PagesPage.tsx";

import { Icon } from "../../../assets/icons/Icon";
import Button from "../../mantine/button/Button";
import actionStyles from "../../ui/dataTable/ActionColumn.module.scss";
import { ActionColumn } from "../../ui/dataTable/DataTable";
import Modal from "../../ui/modal/Modal";
import styles from "./ActionPopover.module.scss";
import { getBulkIgnoreActionFromStatuses } from "./statusConstants";

interface ActionPopoverProps {
  id: number;
  recrawlPage: (id: number) => void;
  ignoreRecrawlPage: (payload: IgnoreRecrawlPayload) => void;
  recrawlEnabled?: boolean;
  ignoreEnabled?: boolean;
  setSelectedIds: (ids: number[] | []) => void;
  pageStatus: Page["status"];
}

const ActionPopover: React.FC<ActionPopoverProps> = ({
  id,
  recrawlPage,
  ignoreRecrawlPage,
  recrawlEnabled = true,
  ignoreEnabled = true,
  pageStatus,
}) => {
  const [isIgnoreModalOpen, setIsIgnoreModalOpen] = useState(false);

  const ignoreAction = getBulkIgnoreActionFromStatuses([pageStatus]);
  const isStatusIgnored = ignoreAction === "include";

  return (
    <>
      <ActionColumn>
        {(close) => (
          <>
            <Button
              variant="menuItem"
              className={actionStyles.popoverItem}
              disabled={!recrawlEnabled}
              onClick={() => {
                close();
                recrawlPage(id);
              }}
            >
              Recrawl
            </Button>
            <Button
              variant="menuItem"
              className={actionStyles.popoverItemRed}
              disabled={!ignoreEnabled}
              onClick={() => {
                close();
                setIsIgnoreModalOpen(true);
              }}
            >
              {isStatusIgnored ? "Include in Crawling" : "Ignore For Crawling"}
            </Button>
          </>
        )}
      </ActionColumn>
      <Modal
        isOpen={isIgnoreModalOpen}
        closeModal={() => setIsIgnoreModalOpen(false)}
        modalLabel={
          <h3 className={styles.modalTitle}>
            <div className={styles.dangerIconWrapper}>
              <Icon iconName="DangerIcon" width="1rem" height="1rem" />
            </div>
            {isStatusIgnored ? "Include in Crawling" : "Ignore For Crawling"}
          </h3>
        }
        buttonLabel={isStatusIgnored ? "Include" : "Ignore"}
        action={() => {
          ignoreRecrawlPage({
            id,
            action: isStatusIgnored ? "include" : "ignore",
          });
          setIsIgnoreModalOpen(false);
        }}
        actionButtonColor="danger"
      >
        {isStatusIgnored ? (
          <p>
            You are about to include this page back into crawling. Once
            included, the page will be added to the crawl queue and processed
            according to your crawl settings. All applicable automations will be
            re-enabled.
          </p>
        ) : (
          <p>
            You are going to ignore page for further crawling. When ignoring a
            page all automations will be removed. You can always reenable
            crawling for the ignored pages.
          </p>
        )}
      </Modal>
    </>
  );
};

export default ActionPopover;
